import { FaArrowLeft } from 'react-icons/fa'
import { Link } from '../lib/router'
import { LINKS } from '../config/links'

const sectionStyle: React.CSSProperties = {
  minHeight: '100vh',
  padding: '120px 1.5rem 4rem',
  display: 'flex',
  justifyContent: 'center',
}

const containerStyle: React.CSSProperties = {
  maxWidth: '800px',
  width: '100%',
}

const headerStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: '2rem',
  paddingBottom: '1rem',
  borderBottom: '1px solid var(--border-color)',
}

const cardStyle: React.CSSProperties = {
  background: 'var(--card-bg)',
  backdropFilter: 'blur(8px)',
  border: '1px solid var(--border-color)',
  borderRadius: '12px',
  padding: '2rem',
  lineHeight: '1.7',
  color: 'var(--text-secondary)',
}

const headingStyle: React.CSSProperties = {
  fontSize: '1.2rem',
  fontWeight: 600,
  marginTop: '1.5rem',
  marginBottom: '0.5rem',
  color: 'var(--accent-color)',
}

const backLinkStyle: React.CSSProperties = {
  color: 'var(--text-secondary)',
  textDecoration: 'none',
  fontSize: '0.9rem',
  display: 'inline-flex',
  alignItems: 'center',
  gap: '0.4rem',
  transition: 'color 0.25s',
}

const PrivacyPage = () => (
  <section style={sectionStyle}>
    <div style={containerStyle}>
      <div style={headerStyle}>
        <h1 style={{ fontSize: '1.5rem', fontWeight: 700, color: 'var(--accent-color)', margin: 0 }}>
          Privacy Policy
        </h1>
        <Link href="/#top" style={backLinkStyle}>
          <FaArrowLeft size={12} /> Back to Portfolio
        </Link>
      </div>
      <div style={cardStyle}>
        <p style={{ marginBottom: '0.8rem' }}><strong style={{ color: 'var(--text-primary)' }}>Effective Date:</strong> June 12, 2026</p>

        <h2 style={headingStyle}>1. Information We Collect</h2>
        <p>This website uses the following data collection methods:</p>
        <ul style={{ paddingLeft: '1.5rem', marginBottom: '0.8rem' }}>
          <li style={{ marginBottom: '0.3rem' }}><strong style={{ color: 'var(--text-primary)' }}>Cloudflare Web Analytics:</strong> Collects anonymized, privacy-first analytics (page views, referrer, browser type, country). No cookies or personal identifiers are stored.</li>
          <li style={{ marginBottom: '0.3rem' }}><strong style={{ color: 'var(--text-primary)' }}>Sentry Error Tracking:</strong> Captures JavaScript errors, browser metadata, and page URLs for debugging. No PII is intentionally collected.</li>
          <li style={{ marginBottom: '0.3rem' }}><strong style={{ color: 'var(--text-primary)' }}>GitHub API Calls:</strong> Fetches public GitHub profile and contribution data. No authentication tokens are exposed to the client.</li>
          <li style={{ marginBottom: '0.3rem' }}><strong style={{ color: 'var(--text-primary)' }}>Local Storage:</strong> Stores theme preference (<code>ma_theme</code>) and debug configuration locally. This data never leaves your browser.</li>
        </ul>

        <h2 style={headingStyle}>2. How We Use Your Data</h2>
        <p>Collected data is used solely for improving website performance, diagnosing technical errors, and understanding aggregate traffic patterns.</p>

        <h2 style={headingStyle}>3. Cookies</h2>
        <p>This website does not set any cookies directly. Cloudflare Web Analytics operates without cookies. Third-party services (Google Fonts, CDN assets) may set their own cookies per their respective policies.</p>

        <h2 style={headingStyle}>4. Third-Party Services</h2>
        <ul style={{ paddingLeft: '1.5rem', marginBottom: '0.8rem' }}>
          <li><strong style={{ color: 'var(--text-primary)' }}>Cloudflare Pages</strong> - Hosting and edge analytics</li>
          <li><strong style={{ color: 'var(--text-primary)' }}>Sentry</strong> - Error monitoring</li>
          <li><strong style={{ color: 'var(--text-primary)' }}>GitHub</strong> - Profile and contribution data API</li>
          <li><strong style={{ color: 'var(--text-primary)' }}>Google Fonts</strong> - Web font delivery</li>
        </ul>

        <h2 style={headingStyle}>5. Data Retention</h2>
        <p>Cloudflare Web Analytics retains aggregated data for 6 months. Sentry retains error events for 90 days. Local storage data persists until you clear your browser data.</p>

        <h2 style={headingStyle}>6. Your Rights (GDPR &amp; CCPA)</h2>
        <p>Depending on your jurisdiction, you may have the right to access, delete, or opt out of data collection. To exercise these rights, contact me at the email below.</p>

        <h2 style={headingStyle}>7. Contact</h2>
        <p>
          Email: <a href="mailto:cs.mohitaroraofficial@gmail.com" style={{ color: 'var(--accent-color)' }}>cs.mohitaroraofficial@gmail.com</a><br />
          LinkedIn: <a href={LINKS.LINKEDIN} target="_blank" rel="noopener noreferrer" style={{ color: 'var(--accent-color)' }}>linkedin.com/in/arora-sir/</a>
        </p>

        <p style={{ fontSize: '0.85rem', opacity: 0.6, marginTop: '1.5rem', textAlign: 'center' }}>Last updated: June 12, 2026</p>
      </div>
    </div>
  </section>
)

export default PrivacyPage
